<div class="w-full py-3 px-4">
  <!-- Firm Title Section -->
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <img class="w-6 h-6 sm:w-8 sm:h-8 lg:w-10 lg:h-10" src="/assets/images/firm/firm.png" alt="firm List" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Firm List</span>
    </div>
    <div>
      <a routerLink="/firm-create"
        class="block cursor-pointer px-3 py-1.5 text-xs sm:text-sm lg:text-base font-semibold text-white bg-c19725 border-2 border-c19725 hover:bg-[#fdffc6] hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center dark:bg-c19725 dark:hover:bg-[#fdffc6]">
        Create New Firm
      </a>
    </div>
  </div>

  <!-- Firm List Desktop View -->
  <div class="mt-4 overflow-x-auto whitespace-nowrap">
    <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
      <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 font-semibold text-xs sm:text-sm lg:text-base">
        <tr>
          <th class="p-2 text-center border-r border-[#0C447D] last:border-r-0">No.</th>
          <th class="p-2 text-left border-r border-[#0C447D] last:border-r-0">Firm ID</th>
          <th class="p-2 text-left border-r border-[#0C447D] last:border-r-0">Firm Name</th>
          <th class="p-2 text-left border-r border-[#0C447D] last:border-r-0">GST Status</th>
          <th class="p-2 text-left border-r border-[#0C447D] last:border-r-0">Date</th>
          <th class="p-2 text-center last:border-r-0 w-24 xl:w-36">Actions</th>
        </tr>
      </thead>
      <tbody class="text-xs sm:text-sm lg:text-base">
        <tr *ngFor="let firm of firmsdata; let i = index; trackBy: trackByFirmId"
          class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]">
          <td class="p-3 text-center">{{ i + 1 }}</td>
          <td class="p-3 text-c19725 font-medium">
            <a role="button" tabindex="0" class="cursor-pointer hover:underline" (click)="openFirmDetails(firm.id)"
              (keydown.enter)="openFirmDetails(firm.id)">
              {{ firm.firm_shortid }}
            </a>
          </td>

          <td class="p-3">{{ firm.name }}</td>
          <td class="p-3">{{ firm.gst_status }}</td>
          <td class="p-3">{{ firm.created_at | date:'dd MMM yyyy' }}</td>
          <td class="p-3 text-center">
            <div class="flex items-center justify-center gap-2 xl:gap-4">

              <!-- View Button -->
              <button aria-label="View Firm Details" class="icon-btn text-blue-600 hover:scale-110 hover:text-blue-800"
                (click)="openFirmDetails(firm.id)" title="View">
                <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <!-- Eye icon with a more rounded, modern style -->
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 4.5C7.305 4.5 3.133 8.118 1.5 12c1.633 3.882 5.805 7.5 10.5 7.5s8.867-3.618 10.5-7.5c-1.633-3.882-5.805-7.5-10.5-7.5z" />
                  <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>
              </button>

              <!-- Edit Button -->
              <button aria-label="Edit Firm" class="icon-btn text-green-600 hover:scale-110 hover:text-green-800"
                (click)="editFirm(firm.id)" title="Edit">
                <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <!-- Modern pencil inside square (edit icon) -->
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </button>


              <!-- Delete Button (unchanged) -->
              <button aria-label="Delete Firm" class="icon-btn text-[#BB0000] hover:scale-110 hover:text-[#990000]"
                (click)="deleteFirm(firm.id)" title="Delete">
                <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" viewBox="0 0 24 25">
                  <path d="M10 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7.5H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>

            </div>
          </td>



        </tr>
      </tbody>
    </table>

    <!-- Firm List Mobile View -->
    <div class="sm:hidden space-y-4">
      <div *ngFor="let firm of firmsdata; let i = index"
        class="relative bg-[#F1F8FF] border border-[#D9D9D9] rounded-lg p-4 shadow">
        <div class="flex items-start justify-start gap-2">
          <p class="text-444 text-sm font-semibold">Firm ID :</p>
          <p class="text-c19725 font-medium text-sm">
            <a [routerLink]="'/firm-view/' + firm.id">{{ firm.firm_shortid }}</a>
          </p>
        </div>
        <div class="flex items-start justify-start gap-2">
          <p class="text-444 text-sm font-semibold">Firm Name :</p>
          <p class="text-[#5A5959] text-sm">{{ firm.name }}</p>
        </div>
        <div class="flex items-start justify-start gap-2">
          <p class="text-444 text-sm font-semibold">Firm Type :</p>
          <p class="text-[#5A5959] text-sm">{{ firm.type }}</p>
        </div>
        <div class="flex items-start justify-start gap-2">
          <p class="text-444 text-sm font-semibold">Date :</p>
          <p class="text-[#5A5959] text-sm">{{ firm.created_at | date:'mediumDate' }}</p>
        </div>
        <div class="flex items-center justify-end mt-3 gap-4">
          <button aria-label="View Firm Details" (click)="openFirmDetails(firm.id)" class="cursor-pointer">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z" />
            </svg>
          </button>
          <button aria-label="Delete Firm" (click)="deleteFirm(i)" class="cursor-pointer">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m2 0a2 2 0 012 2H5a2 2 0 012-2h10z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>